// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._6rthu2gc{margin-block-end:var(--ds-space-100,8px)}\n._bozg1jfw{padding-inline-start:var(--ds-space-500,40px)}", ""]);
// Exports
module.exports = exports;
